"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewControlsType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const ThreeDotButton_1 = require("../../atoms/ThreeDotButton");
const hooks_1 = require("../../hooks");
const AdditionalViewControls_1 = __importDefault(require("../../molecules/AdditionalViewControls"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
var ViewControlsType;
(function (ViewControlsType) {
    ViewControlsType[ViewControlsType["HideOthers"] = 0] = "HideOthers";
    ViewControlsType[ViewControlsType["FadeOthers"] = 1] = "FadeOthers";
    ViewControlsType[ViewControlsType["MultiSelect"] = 2] = "MultiSelect";
    ViewControlsType[ViewControlsType["Hide"] = 3] = "Hide";
    ViewControlsType[ViewControlsType["Fade"] = 4] = "Fade";
    ViewControlsType[ViewControlsType["Isolate"] = 5] = "Isolate";
})(ViewControlsType || (exports.ViewControlsType = ViewControlsType = {}));
// eslint-disable-next-line max-lines-per-function
function ViewControls({ selectedItemViewControl, setSelectedViewControl, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const analytics = (0, analytics_1.useAnalytics)();
    const infoboxControls = (0, hooks_1.useInfoBoxControlsState)();
    const [isOpenAdditional, setIsOpenAdditional] = (0, react_1.useState)(false);
    const sendAnalyticsEvent = (event, title, type) => {
        const segmentation = {
            name: title,
            type: type,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log(event, segmentation);
    };
    const isSelectedAdditionalItem = [
        infoboxControls.hidingOthers,
        infoboxControls.fadingOthers,
        infoboxControls.enableIsolate,
    ].includes(1);
    const onViewControlClick = (type) => {
        setIsOpenAdditional(false);
        if (type !== ViewControlsType.MultiSelect) {
            setSelectedViewControl === null || setSelectedViewControl === void 0 ? void 0 : setSelectedViewControl(type === selectedItemViewControl ? undefined : type);
        }
        switch (type) {
            case ViewControlsType.Hide:
                sendAnalyticsEvent('hide_structure_pressed', t(i18n_1.Strings.infoBox.menu.hidden), ViewControlsType.Hide);
                bridge === null || bridge === void 0 ? void 0 : bridge.hideAction();
                break;
            case ViewControlsType.Fade:
                sendAnalyticsEvent('fade_structure_pressed', t(i18n_1.Strings.infoBox.menu.faded), ViewControlsType.Fade);
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeAction();
                break;
            case ViewControlsType.HideOthers:
                sendAnalyticsEvent('hide_other_structures_pressed', t(i18n_1.Strings.infoBox.menu.hidingOthers), ViewControlsType.HideOthers);
                bridge === null || bridge === void 0 ? void 0 : bridge.hideOthersAction();
                break;
            case ViewControlsType.FadeOthers:
                sendAnalyticsEvent('fade_other_structures_pressed', t(i18n_1.Strings.infoBox.menu.fadingOthers), ViewControlsType.FadeOthers);
                bridge === null || bridge === void 0 ? void 0 : bridge.fadeOthersAction();
                break;
            case ViewControlsType.MultiSelect:
                sendAnalyticsEvent('multiselect_structure_pressed', t(i18n_1.Strings.infoBox.menu.multiSelect), ViewControlsType.MultiSelect);
                bridge === null || bridge === void 0 ? void 0 : bridge.enableMultipleSelection();
                break;
        }
    };
    const onToggleOpenAdditional = () => {
        analytics.log('view_controls_3dot_pressed', {
            name: 'view_controls_3dot' + (isOpenAdditional ? '_closed' : '_opened'),
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        });
        setIsOpenAdditional(!isOpenAdditional);
    };
    const renderViewControlsButton = (type, label, controlState) => {
        return ((0, jsx_runtime_1.jsx)(ui_1.ToolBarBaseButton, { onClick: () => onViewControlClick(type), isSelected: controlState === 1, disabled: controlState === -1, "data-e2e": 'ViewControls_ToolBarBaseButton', children: (0, jsx_runtime_1.jsx)("span", { "data-e2e": 'ViewControls_span', children: label }) }));
    };
    return ((0, jsx_runtime_1.jsxs)(Toolbar, { "data-e2e": 'ViewControls_Toolbar', children: [renderViewControlsButton(ViewControlsType.Hide, t(i18n_1.Strings.infoBox.menu.hidden).toUpperCase(), infoboxControls.hidden), renderViewControlsButton(ViewControlsType.Fade, t(i18n_1.Strings.infoBox.menu.faded).toUpperCase(), infoboxControls.faded), (0, jsx_runtime_1.jsx)(ThreeDotButton_1.ThreeDotButton, { tooltipContext: (0, jsx_runtime_1.jsx)(AdditionalViewControls_1.default, { onClick: onViewControlClick }), tooltipOnForTouchDevice: true, isSelected: isSelectedAdditionalItem, isOpen: isOpenAdditional, onClick: onToggleOpenAdditional, "data-e2e": 'ViewControls_ThreeDotButton' })] }));
}
exports.default = ViewControls;
const Toolbar = styled_components_1.default.div `
  display: flex;
  border-radius: 4px;
  background-color: inherit;
`;
